import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { DollarSignIcon, ArrowRightIcon } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
export function ReferralPage() {
  const heroRef = useRef(null);
  const heroInView = useInView(heroRef, {
    once: true,
    margin: '-100px'
  });
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    telegram: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setFormData({
        name: '',
        email: '',
        telegram: '',
        message: ''
      });
    }, 1500);
  };
  return <div className="min-h-screen" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-354">
      <Navigation data-id="element-355" />

      {/* Hero Section */}
      <section ref={heroRef} className="relative pt-32 pb-20 px-4 overflow-hidden" data-id="element-356">
        <div className="absolute inset-0 overflow-hidden opacity-20" data-id="element-357">
          <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full blur-3xl" style={{
          background: 'radial-gradient(circle, var(--accent) 0%, transparent 70%)'
        }} data-id="element-358" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto" data-id="element-359">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={heroInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6
        }} className="text-center mb-16" data-id="element-360">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight" style={{
            color: 'var(--text-primary)'
          }} data-id="element-361">
              Referral{' '}
              <span style={{
              color: 'var(--accent)'
            }} data-id="element-362">
                Program
              </span>
            </h1>
            <p className="text-lg sm:text-xl max-w-2xl mx-auto" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-363">
              Earn 50% commission on every successful referral
            </p>
          </motion.div>

          <div className="grid gap-8 lg:grid-cols-2 lg:gap-12 max-w-6xl mx-auto items-stretch" data-id="element-364">
            {/* Left - Information */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} animate={heroInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="order-2 lg:order-1" data-id="element-365">
              <div className="rounded-2xl border p-8 h-full flex flex-col" style={{
              borderColor: 'var(--border)',
              backgroundColor: 'var(--bg-secondary)'
            }} data-id="element-366">
                <div className="flex items-center gap-4 mb-8" data-id="element-367">
                  <div className="p-4 rounded-xl" style={{
                  backgroundColor: 'var(--accent)'
                }} data-id="element-368">
                    <DollarSignIcon className="w-8 h-8 text-white" data-id="element-369" />
                  </div>
                  <div data-id="element-370">
                    <h2 className="text-3xl font-bold" style={{
                    color: 'var(--accent)'
                  }} data-id="element-371">
                      €149.50
                    </h2>
                    <p className="text-sm" style={{
                    color: 'var(--text-secondary)'
                  }} data-id="element-372">
                      per successful referral
                    </p>
                  </div>
                </div>

                <div className="space-y-6 flex-1" data-id="element-373">
                  <div data-id="element-374">
                    <h3 className="text-xl font-bold mb-3" style={{
                    color: 'var(--text-primary)'
                  }} data-id="element-375">
                      How It Works
                    </h3>
                    <div className="space-y-4" data-id="element-376">
                      <div className="flex gap-4" data-id="element-377">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold" style={{
                        backgroundColor: 'var(--accent)',
                        color: '#FFFFFF'
                      }} data-id="element-378">
                          1
                        </div>
                        <div data-id="element-379">
                          <p className="font-medium mb-1" style={{
                          color: 'var(--text-primary)'
                        }} data-id="element-380">
                            Recommend Us
                          </p>
                          <p className="text-sm" style={{
                          color: 'var(--text-secondary)'
                        }} data-id="element-381">
                            Share Jetly Agency with friends, colleagues, or your
                            network who need a website.
                          </p>
                        </div>
                      </div>

                      <div className="flex gap-4" data-id="element-382">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold" style={{
                        backgroundColor: 'var(--accent)',
                        color: '#FFFFFF'
                      }} data-id="element-383">
                          2
                        </div>
                        <div data-id="element-384">
                          <p className="font-medium mb-1" style={{
                          color: 'var(--text-primary)'
                        }} data-id="element-385">
                            They Get Demo
                          </p>
                          <p className="text-sm" style={{
                          color: 'var(--text-secondary)'
                        }} data-id="element-386">
                            Your referral receives a free website demo. If they
                            pay €299, you earn.
                          </p>
                        </div>
                      </div>

                      <div className="flex gap-4" data-id="element-387">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold" style={{
                        backgroundColor: 'var(--accent)',
                        color: '#FFFFFF'
                      }} data-id="element-388">
                          3
                        </div>
                        <div data-id="element-389">
                          <p className="font-medium mb-1" style={{
                          color: 'var(--text-primary)'
                        }} data-id="element-390">
                            You Earn 50%
                          </p>
                          <p className="text-sm" style={{
                          color: 'var(--text-secondary)'
                        }} data-id="element-391">
                            Receive €149.50 (50% of €299) paid directly to you
                            within 7 days.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="pt-6 border-t" style={{
                  borderColor: 'var(--border)'
                }} data-id="element-392">
                    <h3 className="text-lg font-bold mb-3" style={{
                    color: 'var(--text-primary)'
                  }} data-id="element-393">
                      Why Join?
                    </h3>
                    <ul className="space-y-2 text-sm" style={{
                    color: 'var(--text-secondary)'
                  }} data-id="element-394">
                      <li className="flex items-center gap-2" data-id="element-395">
                        <span style={{
                        color: 'var(--accent)'
                      }} data-id="element-396">
                          ✓
                        </span>
                        Highest commission rate (50%)
                      </li>
                      <li className="flex items-center gap-2" data-id="element-397">
                        <span style={{
                        color: 'var(--accent)'
                      }} data-id="element-398">
                          ✓
                        </span>
                        No limits on earnings
                      </li>
                      <li className="flex items-center gap-2" data-id="element-399">
                        <span style={{
                        color: 'var(--accent)'
                      }} data-id="element-400">
                          ✓
                        </span>
                        Easy to sell (free demo)
                      </li>
                      <li className="flex items-center gap-2" data-id="element-401">
                        <span style={{
                        color: 'var(--accent)'
                      }} data-id="element-402">
                          ✓
                        </span>
                        Fast payouts (7 days)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Right - Referral Form */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} animate={heroInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="order-1 lg:order-2" data-id="element-403">
              <div className="rounded-2xl border p-8 h-full flex flex-col" style={{
              borderColor: 'var(--border)',
              backgroundColor: 'var(--bg-secondary)'
            }} data-id="element-404">
                <h3 className="text-2xl font-bold mb-2" style={{
                color: 'var(--text-primary)'
              }} data-id="element-405">
                  Join Referral Program
                </h3>
                <p className="text-sm mb-6" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-406">
                  Fill out the form below and we'll contact you with your unique
                  referral link.
                </p>

                <form onSubmit={handleSubmit} className="space-y-5 flex-1 flex flex-col" data-id="element-407">
                  <div data-id="element-408">
                    <label htmlFor="ref-name" className="mb-2 block text-sm font-medium" style={{
                    color: 'var(--text-secondary)'
                  }} data-id="element-409">
                      Your Name *
                    </label>
                    <input type="text" id="ref-name" name="name" value={formData.name} onChange={handleChange} required className="w-full rounded-xl border px-4 py-3 text-sm transition-all focus:outline-none focus:ring-2" style={{
                    borderColor: 'var(--border)',
                    backgroundColor: 'var(--bg-tertiary)',
                    color: 'var(--text-primary)'
                  }} placeholder="John Doe" data-id="element-410" />
                  </div>

                  <div data-id="element-411">
                    <label htmlFor="ref-email" className="mb-2 block text-sm font-medium" style={{
                    color: 'var(--text-secondary)'
                  }} data-id="element-412">
                      Email Address *
                    </label>
                    <input type="email" id="ref-email" name="email" value={formData.email} onChange={handleChange} required className="w-full rounded-xl border px-4 py-3 text-sm transition-all focus:outline-none focus:ring-2" style={{
                    borderColor: 'var(--border)',
                    backgroundColor: 'var(--bg-tertiary)',
                    color: 'var(--text-primary)'
                  }} placeholder="john@example.com" data-id="element-413" />
                  </div>

                  <div data-id="element-414">
                    <label htmlFor="ref-telegram" className="mb-2 block text-sm font-medium" style={{
                    color: 'var(--text-secondary)'
                  }} data-id="element-415">
                      Telegram Username
                    </label>
                    <input type="text" id="ref-telegram" name="telegram" value={formData.telegram} onChange={handleChange} className="w-full rounded-xl border px-4 py-3 text-sm transition-all focus:outline-none focus:ring-2" style={{
                    borderColor: 'var(--border)',
                    backgroundColor: 'var(--bg-tertiary)',
                    color: 'var(--text-primary)'
                  }} placeholder="@johndoe" data-id="element-416" />
                  </div>

                  <div className="flex-1" data-id="element-417">
                    <label htmlFor="ref-message" className="mb-2 block text-sm font-medium" style={{
                    color: 'var(--text-secondary)'
                  }} data-id="element-418">
                      Tell Us About Your Network
                    </label>
                    <textarea id="ref-message" name="message" value={formData.message} onChange={handleChange} rows={4} className="w-full resize-none rounded-xl border px-4 py-3 text-sm transition-all focus:outline-none focus:ring-2" style={{
                    borderColor: 'var(--border)',
                    backgroundColor: 'var(--bg-tertiary)',
                    color: 'var(--text-primary)'
                  }} placeholder="Who do you plan to refer? (e.g., small business owners, entrepreneurs, etc.)" data-id="element-419" />
                  </div>

                  <motion.button type="submit" disabled={isSubmitting} whileHover={{
                  scale: 1.02
                }} whileTap={{
                  scale: 0.98
                }} className="w-full rounded-xl py-4 font-semibold transition-all disabled:cursor-not-allowed disabled:opacity-70" style={{
                  backgroundColor: 'var(--accent)',
                  color: '#FFFFFF'
                }} data-id="element-420">
                    <span className="flex items-center justify-center gap-2" data-id="element-421">
                      {isSubmitting ? 'Submitting...' : <>
                          Join Program
                          <ArrowRightIcon className="h-5 w-5" data-id="element-422" />
                        </>}
                    </span>
                  </motion.button>

                  <p className="text-xs text-center" style={{
                  color: 'var(--text-muted)'
                }} data-id="element-423">
                    By joining, you agree to our referral program terms
                  </p>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <Footer data-id="element-424" />
      <CookieBanner data-id="element-425" />
    </div>;
}